import React, { useState } from 'react';
import Button from './atoms/Button';
import TextTitleCard from './atoms/TitleTextCard';
import TicketDTO from '../models/ticket';
import CurrencyInput from './atoms/CurrencyInput';

interface OpenPriceCardProps {
  onAmountChange: (amount: number | undefined) => void;
  ticket: TicketDTO;
}

const OpenPriceCard: React.FC<OpenPriceCardProps> = ({ ticket, onAmountChange }) => {
  const [isAmountSet, setIsAmountSet] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [amount, setAmount] = useState(0);

  if (!ticket.has_open_price || !ticket.min_open_price) {
    throw new Error('ticket does not have open price');
  }

  const validateAmount = () => {
    const numericAmount = amount;
    if (Number.isNaN(numericAmount)) {
      setErrMsg('Valor ingresado no es correcto');
      return false;
    }
    if (ticket.min_open_price && numericAmount < ticket.min_open_price) {
      setErrMsg(`El monto debe ser superior a ${ticket.min_open_price}`);
      return false;
    }
    return true;
  };

  const handleApplyAmount = () => {
    setErrMsg('');
    if (isAmountSet) {
      setIsAmountSet(false);
      setAmount(0);
      onAmountChange(undefined);
    } else if (validateAmount()) {
      setIsAmountSet(true);
      onAmountChange(amount);
    }
  };

  const handleAmountChange = (value: number) => {
    setAmount(value);
  };

  return (
    <TextTitleCard title="Monto a abonar" hr={false}>
      <div>
        <div className="flex flex-row gap-4">
          <CurrencyInput
            id="code"
            label="Monto"
            value={amount}
            onChange={handleAmountChange}
            errMsg={errMsg}
            disabled={isAmountSet}
          />
          <div className='w-full max-w-md'>
            <Button
              type="button"
              variant="primary"
              onClick={handleApplyAmount}
            >
              {isAmountSet ? 'Cancelar' : 'Aplicar'}
            </Button>
          </div>
        </div>
      </div>
    </TextTitleCard>
  );
};

export default OpenPriceCard;
